export const CONTACT_VISIBILITY_KEYS = [
  'showBluesky',
  'showDiscord',
  'showEmail',
  'showGithub',
  'showGithubHandle',
  'showGithubProjects',
  'showLinkedin',
  'showTelegram',
  'showTwitter',
] as const;
